import React from 'react';
import { GetCustomerDashboardDto } from 'services/Dtos/GetCustomerDashboardDto';

interface CustomerOverviewTabProps {
  customer: GetCustomerDashboardDto;
  formData: {
    phone: string;
    email: string;
  };
}

const CustomerOverviewTab: React.FC<CustomerOverviewTabProps> = ({ customer, formData }) => {
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body">
        {/* Company Name Section */}
        <div className="mb-4">
          <h6 className="text-muted mb-3">
            <i className="bi bi-building me-2"></i>
            Company Name
          </h6>
          <p className="fs-5 fw-semibold mb-0">{customer.name}</p>
        </div>

        <hr className="my-4" />

        {/* Contact Information Section */}
        <div className="mb-4">
          <h6 className="text-muted mb-3">
            <i className="bi bi-person-lines-fill me-2"></i>
            Contact Information
          </h6>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label text-muted small">Phone</label>
              <p className="mb-0">{formData.phone || '-'}</p>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-muted small">Email</label>
              <p className="mb-0">{formData.email || '-'}</p>
            </div>
          </div>
        </div>

        <hr className="my-4" />

        {/* API Keys Summary Section */}
        <div>
          <h6 className="text-muted mb-3">
            <i className="bi bi-key me-2"></i>
            API Keys Summary
          </h6>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label text-muted small">Total API Keys</label>
              <p className="mb-0">
                <span className="badge bg-primary fs-6">{customer.apiKeys.length}</span>
              </p>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label text-muted small">Gemini Enabled Keys</label>
              <p className="mb-0">
                <span className="badge bg-success fs-6">
                  {customer.apiKeys.filter(key => key.shouldUseGemini).length}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerOverviewTab;
